module.exports = __webpack_public_path__ + "static/media/details-more.a2b45814.svg";